import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'components',
    pluginName: 'PRODUCT',
    entityName: 'NIC',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch nic action creators

export const fetchNICInit = () => {
    return crudActions.fetchInit();
};
export const fetchNICStart = () => {
    return crudActions.fetchStart();
};
export const fetchNICSuccess = (fetchNICCount, listNICCount) => {
    return crudActions.fetchSuccess(fetchNICCount, listNICCount);
};
export const fetchNICFail = () => {
    return crudActions.fetchFail();
};



export const fetchNICCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchNICStart());
        try {
            let countRes = await rest.post("components/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchNICSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchNICFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch NIC."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchNICFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch NIC."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchNIC = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchNICStart());
        try {
            let listRes = await rest.post("components/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchNICSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchNICFail());
            return []

        } catch (error) {
            dispatch(fetchNICFail());
            return []
        }
    }
}

// Load nic action creators
export const loadNICInit = () => {
    return crudActions.loadInit();
};
export const loadNICStart = () => {
    return crudActions.loadStart();
};
export const loadNICSuccess = loadedNIC => {
    return crudActions.loadSuccess(loadedNIC);
};
export const loadNICFail = error => {
    return crudActions.loadFail(error);
};
export const loadNIC = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create nic  action creators
export const createNICInit = () => {
    return crudActions.createInit();
};
export const createNICStart = () => {
    return crudActions.createStart();
};
export const createNICSuccess = createdNIC => {
    return crudActions.createSuccess(createdNIC);
};
export const createNICFail = error => {
    return crudActions.createFail(error);
};

export const createNIC = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createNICStart());
        try {
            let res = await rest.post('/components/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createNICSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created nic.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createNICFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create nic."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create nic."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createNICFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit nic  action creators
export const editNICInit = () => {
    return crudActions.editInit();
};
export const editNICStart = () => {
    return crudActions.editStart();
};
export const editNICSuccess = editedNIC => {
    return crudActions.editSuccess(editedNIC);
};
export const editNICFail = error => {
    return crudActions.editFail(error);
};
export const editNIC = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editNICStart());
        try {
            let res = await rest.post('/components/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editNICSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated nic.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editNICFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit nic."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit nic."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editNICFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}



// Bulk delete nic action creators
export const bulkDeleteNICsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteNICsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteNICsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteNICsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteNICs = nicIds => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, nicIds);
    };
};

// Delete nic  action creators
export const deleteNICInit = () => {
    return crudActions.deleteInit();
};
export const deleteNICStart = () => {
    return crudActions.deleteStart();
};
export const deleteNICSuccess = deletedNIC => {
    return crudActions.deleteSuccess(deletedNIC);
};
export const deleteNICFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteNIC = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};
export const setNics = (data) => {
    return ({
        type: 'HANDLE_NICS',
        nics: { ...data, fromProduct: true }
    });
}
export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}
